import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.SentencePartsChalkboard.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.SentencePartsChalkboard.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.instructions = null;
  this.words = [];
  this.correctAnswers = 0;
  this.fillStyles = [];
  this.labels = [];
};

// eslint-disable-next-line max-len
EDC.Games.SentencePartsChalkboard.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.SentencePartsChalkboard.Scenes.Main.prototype.constructor = EDC.Games.SentencePartsChalkboard.Scenes.Main;

const IPIS = EDC.Games.SentencePartsChalkboard.Scenes.Main.prototype;

IPIS.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

IPIS.loadIteration = function () {
  this.addInstructions();
  this.addSentence();
};

IPIS.nextIteration = function () {
  this.instructions.destroy();
  this.correctAnswers = 0;
  this.fillStyles.map(x => x.destroy());
  this.labels.map(x => x.destroy());
  this.words.map((x) => {
    x.destroy();
    x.leftSprite.destroy();
    x.midSprite.destroy();
    x.rightSprite.destroy();
    x.interactiveBox.destroy();
  });
  this.fillStyles = [];
  this.labels = [];
  this.instructions = null;
  this.words = [];
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

IPIS.createTemplateUI = function () {
  this.add.sprite(955, 155, 'title');
  const rect = new Phaser.Geom.Rectangle(230, 460, 1400, 150);
  const hitArea = this.add.graphics({ fillStyle: { alpha: 0 } });
  hitArea.fillRectShape(rect);
  hitArea.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
  this.cursorManager.setDefaultDraggableEvents(hitArea);
};

IPIS.addInstructions = function () {
  const boardWidth = 1400;
  const boardX = (this.game.config.width - boardWidth) / 2;
  const instructionsFont = {
    font: `${this.gameConfig.instructionsSize} ${this.gameConfig.font}`,
  };
  const { instructions } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const instruction = this.add.text(0, 720, instructions, instructionsFont);
  const x = boardX + (1400 - instruction.displayWidth) / 2;
  instruction.x = x;
  this.instructions = instruction;
};

IPIS.getStartingX = function () {
  let sentenceWidth = 0;
  let sentenceX = 0;
  const boardWidth = 1400;
  const boardX = (this.game.config.width - boardWidth) / 2;
  const { sentence } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const sentenceArray = sentence.split(' ');
  const font = this.getFont();
  // add objects so they have actual width
  let condition;
  if (sentenceArray.length > 7) {
    condition = 7;
  } else {
    condition = sentenceArray.length;
  }
  for (let i = 0; i < condition; i++) {
    const word = this.add.text(200, 200, sentenceArray[i], font).setDepth(1);
    sentenceArray[i] = word;
  }
  // after getting object width just remove them
  for (let i = 0; i < condition; i++) {
    sentenceWidth += sentenceArray[i].width + 70;
    sentenceArray[i].destroy();
  }
  sentenceWidth -= 70;
  sentenceX = boardX + (1400 - sentenceWidth) / 2;
  return sentenceX;
};

IPIS.getFont = function () {
  const font = {
    font: '160px chalk',
  };
  return font;
};

IPIS.addSentence = function () {
  const { sentence } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const sentenceArray = sentence.split(' ');
  const font = this.getFont();
  let y;
  for (let i = 0; i < sentenceArray.length; i++) {
    const x = this.getWordPosition(i, sentenceArray);
    if (sentenceArray.length < 8) {
      y = 400;
    } else if (i > 6) {
      y = 480;
    } else {
      y = 300;
    }
    const word = this.add.text(x, y, sentenceArray[i], font).setDepth(1);
    sentenceArray[i] = word;
    this.createBox(word);
    this.makeBoxInteractive(word);
    this.boxAnimation(word);
    word.interactiveBox.on('pointerup', this.checkAnswer.bind(this, word), this);
    this.words.push(word);
  }
};

IPIS.addMark = function (word, isCorrect) {
  let mark;
  if (isCorrect) {
    mark = this.add.sprite(word.boxX + 8 + word.boxWidth / 2, word.boxY - 5, 'check').setDepth(1);
  } else {
    mark = this.add.sprite(word.boxX + 8 + word.boxWidth / 2, word.boxY - 5, 'cross').setDepth(1);
  }
  this.labels.push(mark);
};

IPIS.changeColor = function (word, isCorrect) {
  let graphicsObject;
  const visual = new Phaser.Geom.Rectangle(
    word.boxX - 4,
    word.boxY + 3 - word.boxHeight / 2,
    word.boxWidth + 18,
    word.boxHeight - 6,
  );
  if (isCorrect) {
    graphicsObject = this.add.graphics({ fillStyle: { color: 0x006400, alpha: 1 } });
    graphicsObject.fillRectShape(visual);
    this.fillStyles.push(graphicsObject);
  } else {
    graphicsObject = this.add.graphics({ fillStyle: { color: 0xff0000, alpha: 1 } });
    graphicsObject.fillRectShape(visual);
    this.shakeAnimation(word, graphicsObject);
    this.fillStyles.push(graphicsObject);
  }
};

IPIS.shakeAnimation = function (word, graphicsObject) {
  const shake = [];
  shake.push(graphicsObject);
  shake.push(word.leftSprite);
  shake.push(word.midSprite);
  shake.push(word.rightSprite);
  shake.push(word);
  for (let i = 0; i < shake.length; i++) {
    this.tweens.add({
      targets: shake[i],
      x: shake[i].x - 10,
      duration: 30,
      ease: 'Linear',
      repeat: 3,
      yoyo: true,
    });
  }
};

IPIS.makeBoxInteractive = function (word) {
  const active = new Phaser.Geom.Rectangle(
    word.boxX - 40,
    word.boxY - word.boxHeight / 2,
    word.boxWidth + 18,
    word.boxHeight,
  );
  const graphicsObject = this.add.graphics();
  graphicsObject.setInteractive(active, Phaser.Geom.Rectangle.Contains);
  this.cursorManager.setDefaultDraggableEvents(graphicsObject);
  word.interactiveBox = graphicsObject;
};

IPIS.getWordPosition = function (index, sentenceArray) {
  let x;
  if (index % 7 === 0) {
    x = this.getStartingX();
    return x;
  }
  x = sentenceArray[index - 1].x + sentenceArray[index - 1].displayWidth + 50;
  return x;
};

IPIS.boxAnimation = function (word) {
  word.scaleAnim = this.tweens.add({
    targets: [word.rightSprite, word.midSprite, word.leftSprite],
    scaleX: '+=0.2',
    scaleY: '+=0.1',
    duration: 300,
    ease: 'Linear',
    yoyo: true,
    delay: 6500,
    onComplete: this.boxAnimation.bind(this, word),
  });
};

IPIS.checkAnswer = function (word) {
  let isCorrect = false;
  const { correctAnswer } = this.gameConfig.sets[
    this.difficulty
  ].iterations[this.iteration].correctAnswer;
  const correctCount = correctAnswer.length;
  for (let i = 0; i < correctAnswer.length; i++) {
    if (word.text === this.words[correctAnswer[i] - 1].text) {
      isCorrect = true;
      break;
    } else {
      isCorrect = false;
    }
  }
  if (isCorrect) {
    this.correctAnswers = this.correctAnswers + 1;
    word.interactiveBox.disableInteractive();
    word.scaleAnim.stop();
    this.changeColor(word, true);
    this.addMark(word, true);
    if (this.correctAnswers === correctCount) {
      this.playCorrect();
      this.words.map((x) => {
        x.interactiveBox.disableInteractive();
        x.scaleAnim.stop();
      });
      this.time.delayedCall(2000, this.nextIteration, [], this);
    }
  } else {
    this.playWrong();
    word.interactiveBox.disableInteractive();
    word.scaleAnim.stop();
    this.addMark(word, false);
    this.changeColor(word, false);
  }
};

IPIS.createBox = function (word) {
  const padding = 10;
  const width = word.displayWidth + padding;
  const left = this.add.sprite(0, 0, 'left');
  const mid = this.add.sprite(0, 0, 'mid');
  const right = this.add.sprite(0, 0, 'right');
  mid.displayWidth = width;
  this.placeBox(left, mid, right, word, width, padding);
  word.leftSprite = left;
  word.midSprite = mid;
  word.rightSprite = right;
};

IPIS.placeBox = function (left, mid, right, word, width, padding) {
  const height = 120;
  left.displayHeight = height;
  mid.displayHeight = height;
  right.displayHeight = height;
  left.x = word.x - padding / 2;
  left.y = word.y + height;
  mid.x = word.x + width / 2;
  mid.y = word.y + height;
  right.x = word.x + width + padding / 2;
  right.y = word.y + height;
  word.x += 5;
  word.boxWidth = width;
  word.boxHeight = height;
  word.boxX = left.x;
  word.boxY = left.y;
};

export default EDC.Games.SentencePartsChalkboard.Scenes.Main;
